import * as Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/vuex'

import WebFont from 'webfontloader';

WebFont.load({ google: { families: ["DM Sans:regular,500,700"] } })

export const assetUrl = 'https://mara-donationwidget.netlify.app';

import axios from "axios";
import VueAxios from "vue-axios";

const app = Vue.createApp(App)
app.use(VueAxios, axios)


app.use(router).use(store).mount('#donation-widget')
